module.exports = __webpack_public_path__ + "static/media/noun_rotation_2574812.1bb781ff.svg";